import { render, staticRenderFns } from "./ia-cliente-transcricoes.vue?vue&type=template&id=48119aaf&scoped=true&"
import script from "./ia-cliente-transcricoes.vue?vue&type=script&lang=js&"
export * from "./ia-cliente-transcricoes.vue?vue&type=script&lang=js&"
import style0 from "./ia-cliente-transcricoes.vue?vue&type=style&index=0&id=48119aaf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48119aaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48119aaf')) {
      api.createRecord('48119aaf', component.options)
    } else {
      api.reload('48119aaf', component.options)
    }
    module.hot.accept("./ia-cliente-transcricoes.vue?vue&type=template&id=48119aaf&scoped=true&", function () {
      api.rerender('48119aaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/ia-cliente-painel/ia-cliente-transcricoes.vue"
export default component.exports